import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const EnergyImportantIcon = (t0)=>{
    const $ = c(11);
    const { width, height, color } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== color) {
        t2 = /*#__PURE__*/ jsx("circle", {
            cx: "10",
            cy: "10",
            r: "10",
            fill: color
        });
        $[1] = color;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.2839 4.57822C12.0208 5.3 11.8 6.3 11.1362 6.99807L9.5 8.5H13.9385C15.8325 8.5 16.7203 10.6283 15.302 11.8834L11.1362 15.5695C10.4271 16.1969 9.34359 16.1308 8.71608 15.4218C8.08857 14.7128 8.05 13.8 8.86379 13.0019L10.5 11.5H6.0615C4.16747 11.5 3.27969 9.37166 4.69805 8.11662L8.86379 4.43053C9.57288 3.80309 10.6564 3.86921 11.2839 4.57822Z",
            fill: "white"
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2) {
        t4 = /*#__PURE__*/ jsxs("g", {
            clipPath: "url(#clip0_14883_174521)",
            children: [
                t1,
                t2,
                t3
            ]
        });
        $[4] = t2;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ jsx("defs", {
            children: /*#__PURE__*/ jsx("clipPath", {
                id: "clip0_14883_174521",
                children: /*#__PURE__*/ jsx("rect", {
                    width: "20",
                    height: "20",
                    rx: "10",
                    fill: "white"
                })
            })
        });
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== height || $[8] !== t4 || $[9] !== width) {
        t6 = /*#__PURE__*/ jsxs("svg", {
            viewBox: "0 0 20 20",
            width: width,
            height: height,
            children: [
                t4,
                t5
            ]
        });
        $[7] = height;
        $[8] = t4;
        $[9] = width;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
};
export { EnergyImportantIcon };
